// Copyright © 2024 Christopher Laux <mail@chrislaux.com>

import $ from 'jquery';

import { setupTable } from './lib.js';

$(function () {
    setupTable(true);
});
